import { LocationDto } from "../dtos/LocationDto"


export class Utils {
    private static GOOGLEMAP_BASE_URL = "https://www.google.com/maps/embed/v1/place?";
    private static GOOGLEMAP_BASE_URL_SEARCH = "https://www.google.com/maps/search/?api=1&";
    private static GOOGLE_MAP_API_KEY = "AIzaSyDwKAV3mFMrS-Y2iyrtz_lRfR8U70gq0-A";

    public static getGoogleMap(location: LocationDto): string {
        var locationString = LocationDto.getAddressString(location);

        const params = { key: this.GOOGLE_MAP_API_KEY, q: locationString }
        const paramString = new URLSearchParams(params);

        const url = this.GOOGLEMAP_BASE_URL + paramString;
        return url;

    }

    

    public static getLinkToGoogleMap(location: LocationDto): string {

        const params = { query: LocationDto.getAddressString(location) }
        const paramString = new URLSearchParams(params);
        const url = this.GOOGLEMAP_BASE_URL_SEARCH + paramString;
        return url;


    }

    public static isStringEmpty(str: String): boolean {
        return (typeof str === "undefined" || !str || str === "" || str === " " || str.length == 0 )
    }
}